const map = [
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,4,4,1,],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,4,4,1,],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,0,0,0,0,0,0,0,4,4,1,],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,3,3,3,0,0,0,0,0,0,1,],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,],
  [0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,],
  [0,0,3,3,3,0,0,0,0,3,0,1,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,],
  [0,0,0,0,0,0,0,0,0,3,0,1,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,],
  [0,0,0,0,0,0,0,0,0,3,0,1,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,],
  [1,1,2,1,1,0,0,0,0,0,0,1,0,0,0,0,0,3,3,3,0,1,0,0,0,0,0,0,0,0,0,0,0,1,],
  [0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,1,1,1,2,1,1,0,0,0,0,0,0,1,],
  [0,0,0,0,1,1,1,1,1,2,1,1,0,0,0,0,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,0,1,],
  [0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,0,0,0,1,0,3,0,0,3,0,1,],
  [0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,0,0,0,1,0,3,0,0,3,0,1,],
  [0,0,0,0,1,0,0,0,3,0,0,1,0,0,0,0,0,0,0,0,0,2,0,0,0,0,1,0,3,0,0,3,0,1,],
  [1,1,2,1,1,0,0,0,3,0,0,1,0,0,0,0,0,0,0,0,0,1,0,3,0,0,1,0,0,0,0,0,0,1,],
  [0,0,0,0,1,0,0,0,3,0,0,1,0,0,0,0,0,0,3,0,0,1,0,3,0,0,1,0,0,0,0,0,0,1,],
  [0,0,0,0,1,0,0,0,0,0,0,2,0,0,0,0,0,0,3,0,0,1,0,3,0,0,2,0,0,0,0,0,0,1,],
  [0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,3,0,0,1,0,0,0,0,1,0,0,0,0,0,0,1,],
  [0,0,0,0,1,0,0,0,0,0,0,1,3,3,3,0,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,0,1,],
];

export default map;
